module.exports = __webpack_public_path__ + "img/xinj.00cac0a8.svg";